import PropTypes from "prop-types";

// Components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";
import { ProductItem } from "./ProductItem";

// MUI
import { Grid } from "@mui/material";

export default function TierProducts(props) {
	const {
		rows = [],
		rowItemSpaces = {
			mainSection: 155.82,
			columns: 215.94,
			totalColumns: 1,
			separation: 10,
			reduction: 0,
		},
		rowItemSx = { width: "100%" },
		units = {
			firstInputIndex: "from",
			secondInputIndex: "to",
			callbacks: { onActionUpdate: () => {} },
		},
		unitsData = {
			firstInputData: [
				{
					type: "Unit",
					min: 0,
					max: 10000,
					decimalsEditable: true,
					decimals: 1,
					dashed: false,
					delta: 0.5,
				},
			],
			secondInputData: [
				{
					type: "Unit",
					min: 0,
					max: 10000,
					decimalsEditable: true,
					decimals: 1,
					dashed: false,
					delta: 0.5,
				},
			],
		},
		productsAreas = {
			front: {
				area: "front",
				main: "frontGross",
				products: "frontProducts",
			},
			back: {
				area: "back",
				main: "backGross",
				products: "backProducts",
			},
		},
		productWidthAreas = {
			front: {
				total: 3,
				items: 12,
			},
			back: {
				total: 3,
				items: 12,
			},
		},
		errorsUnits = [],
		frontAvailableProducts = [],
		backAvailableProducts = [],
		inputRelated = {
			area: "",
			column: "",
		},
		selectRelated = {
			area: "",
			column: "",
		},
		blinkSelect = false,
		errorCommission = [],
		backGrossErrors = [],
		frontProductsErrors = [],
		backProductsErrors = [],
		errorPercentageFront = [],
		errorPercentageBack = [],
		readOnly = false,
		productsCallbacks = {
			onClickInput: () => {},
			onFocusOut: () => {},
			onChangeType: () => {},
			onActionUpdate: () => {},
		},
		selectionCallbacks = {
			onSelect: () => {},
			onSelectOpen: () => {},
			onSelectClose: () => {},
		},
		rowProps = {
			direction: "row",
			justifyContent: "flex-start",
			columnSpacing: 4,
			className: "simple-transition",
			xs: 12,
		},
		rowsContainerProps = {
			direction: "row",
			spacing: 2,
			mt: "-10px",
		},
	} = props;

	return (
		<Grid container {...rowsContainerProps}>
			{rows.map((element, key) => {
				const firstElement = Boolean(!key);
				const lastElement = Boolean(rows.length - 1 === key);

				return (
					<Grid key={key} container item>
						<TierRowsItem hasShadow={!(key % 2)} spaces={rowItemSpaces} sxModifiers={rowItemSx}>
							<Grid container item {...rowProps}>
								<Grid item xs={12} md={2} className={"simple-transition"}>
									<DoubleInput
										firstInput={{
											data: unitsData.firstInputData?.map((input) => ({ ...input, dashed: firstElement })),
											value: element?.[units.firstInputIndex]?.value || 0,
											defaultType: element?.[units.firstInputIndex]?.input || "Unit",
											error: errorsUnits?.[key]?.[units.firstInputIndex],
											disabled: true,
											readOnly: true,
											onActionUpdate: (value, input) => {
												units?.callbacks?.onActionUpdate?.(units.firstInputIndex, key, value, input);
											},
										}}
										secondInput={{
											data: unitsData.secondInputData?.map((input) => ({ ...input, dashed: lastElement })),
											value: element?.[units.secondInputIndex]?.value || 0,
											defaultType: element?.[units.secondInputIndex]?.input || "Unit",
											error: errorsUnits?.[key]?.[units.secondInputIndex],
											disabled: readOnly || lastElement,
											readOnly: readOnly || lastElement,
											onActionUpdate: (value, input) => {
												units?.callbacks?.onActionUpdate?.(units.secondInputIndex, key, value, input);
											},
										}}
									/>
								</Grid>
								<Grid
									item
									xs={12}
									md={productWidthAreas.front?.total || 12}
									className={"simple-transition"}
									style={productWidthAreas.front?.total === 3 ? { maxWidth: "22%" } : null}
								>
									<ProductItem
										index={key}
										readOnly={readOnly}
										width={productWidthAreas.front?.items || 6}
										areas={productsAreas?.front}
										products={element?.[productsAreas?.front?.products] || []}
										availableProducts={frontAvailableProducts}
										productsError={errorPercentageFront?.[key]?.[productsAreas?.front?.main]}
										productsErrors={frontProductsErrors?.[key]}
										inputRelated={inputRelated}
										selectRelated={selectRelated}
										blink={blinkSelect}
										mainInput={element?.[productsAreas?.front?.main] || null}
										mainSelectOptions={{
											text: "Total Gross Profit",
											useLabel: true,
											related: false,
										}}
										mainGeneralAttributes={{
											key: productsAreas?.front?.main || "firstProduct",
											error:
												errorCommission?.[key]?.[productsAreas?.front?.main] ||
												errorPercentageFront?.[key]?.[productsAreas?.front?.main],
											related:
												inputRelated?.area === productsAreas?.front?.area &&
												inputRelated?.column === productsAreas?.front?.main,
											addSeparator: false,
										}}
										actionsCallbacks={productsCallbacks}
										selectionCallbacks={selectionCallbacks}
									/>
								</Grid>
								<Grid
									item
									xs={12}
									md={productWidthAreas.back?.total || 12}
									className={"simple-transition"}
									style={productWidthAreas.back?.total === 3 ? { maxWidth: "22%" } : null}
								>
									<ProductItem
										index={key}
										readOnly={readOnly}
										width={productWidthAreas.back?.items || 6}
										areas={productsAreas?.back}
										products={element?.[productsAreas?.back?.products] || []}
										availableProducts={backAvailableProducts}
										productsError={errorPercentageBack?.[key]?.[productsAreas?.back?.main]}
										productsErrors={backProductsErrors?.[key]}
										inputRelated={inputRelated}
										selectRelated={selectRelated}
										blink={blinkSelect}
										mainInput={element?.[productsAreas?.back?.main] || null}
										mainSelectOptions={{
											text: "Total Gross Profit",
											useLabel: true,
											related: false,
										}}
										mainGeneralAttributes={{
											key: productsAreas?.back?.main || "firstProduct",
											error:
												backGrossErrors?.[key]?.[productsAreas?.back?.main] ||
												errorPercentageBack?.[key]?.[productsAreas?.back?.main],
											related:
												inputRelated?.area === productsAreas?.back?.area &&
												inputRelated?.column === productsAreas?.back?.main,
											addSeparator: false,
										}}
										actionsCallbacks={productsCallbacks}
										selectionCallbacks={selectionCallbacks}
									/>
								</Grid>
							</Grid>
						</TierRowsItem>
					</Grid>
				);
			})}
		</Grid>
	);
}

TierProducts.propTypes = {
	rows: PropTypes.array,
	rowItemSpaces: PropTypes.object,
	rowItemSx: PropTypes.object,
	units: PropTypes.object,
	unitsData: PropTypes.object,
	productsAreas: PropTypes.object,
	productWidthAreas: PropTypes.object,
	errorsUnits: PropTypes.array,
	frontAvailableProducts: PropTypes.array,
	backAvailableProducts: PropTypes.array,
	inputRelated: PropTypes.object,
	selectRelated: PropTypes.object,
	blinkSelect: PropTypes.bool,
	errorCommission: PropTypes.array,
	backGrossErrors: PropTypes.array,
	frontProductsErrors: PropTypes.array,
	backProductsErrors: PropTypes.array,
	errorPercentageFront: PropTypes.array,
	errorPercentageBack: PropTypes.array,
	readOnly: PropTypes.bool,
	productsCallbacks: PropTypes.object,
	selectionCallbacks: PropTypes.object,
	rowProps: PropTypes.object,
	rowsContainerProps: PropTypes.object,
};
